import React, { useState } from 'react';
import { Button } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { signInWithFacebook } from '../services/facebookAuth';
import { setUser } from '../store/slices/User';

interface FacebookSignInButtonProps {
  fullWidth?: boolean;
  variant?: 'contained' | 'outlined' | 'text';
  disabled?: boolean;
  onSuccess?: (idToken: string) => void;
  onError?: (error: string) => void;
}

const FacebookSignInButton: React.FC<FacebookSignInButtonProps> = ({
  fullWidth = true,
  variant = 'outlined',
  disabled = false,
  onSuccess,
  onError,
}) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleFacebookSignIn = async () => {
    setLoading(true);
    try {
      const response = await signInWithFacebook();
      const { user, idToken } = response;

      // Prepare user data
      const userData = {
        _id: user.uid,
        email: user.email,
        username: user.displayName || user.email?.split('@')[0],
        firstName: user.displayName?.split(' ')[0] || '',
        lastName: user.displayName?.split(' ')[1] || '',
        photoURL: user.photoURL,
        emailVerified: user.emailVerified,
        isFacebookUser: true,
      };

      dispatch(setUser(userData));

      if (onSuccess) {
        onSuccess(idToken || '');
      } else {
        navigate('/');
      }
    } catch (error: any) {
      console.error('Facebook sign-in failed:', error);
      if (onError) {
        onError(error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      fullWidth={fullWidth}
      variant={variant}
      onClick={handleFacebookSignIn}
      disabled={disabled || loading}
      sx={{
        textTransform: 'none',
        borderColor: '#F57C00',
        color: '#3c4043',
        backgroundColor: '#FFF3E0',
        height: '40px',
        fontSize: '14px',
        fontWeight: 500,
        mb: 1,
      }}
      // startIcon={<FacebookIcon />}
    >
      {loading ? 'Signing in...' : 'Continue with Facebook'}
    </Button>
  );
};

export default FacebookSignInButton; 